import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "checkoutview" }
const _hoisted_2 = {
  key: 0,
  class: "bigbox flex v-center center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex center" }
const _hoisted_5 = {
  key: 0,
  class: "error flex gap v-center"
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  id: "checkoutContent",
  class: "content flex gap-2"
}
const _hoisted_8 = { class: "grow-1 flex-col gap" }
const _hoisted_9 = { class: "naked info-box flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_contact_info_box = _resolveComponent("contact-info-box")!
  const _component_item_info_box = _resolveComponent("item-info-box")!
  const _component_additional_info_box = _resolveComponent("additional-info-box")!
  const _component_pre_payment_info_box = _resolveComponent("pre-payment-info-box")!
  const _component_LoaderDisplay = _resolveComponent("LoaderDisplay")!
  const _component_order_summary_info_box = _resolveComponent("order-summary-info-box")!
  const _component_alert_modal = _resolveComponent("alert-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_loader_display)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "gg-danger" }, null, -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.error ?? 'Unknown Error'), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_contact_info_box, {
                isActive: _ctx.activeBox == _ctx.BoxType.CONTACT,
                canEdit: _ctx.validContact,
                onOnNext: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleNext())),
                onOnEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEdit(_ctx.BoxType.CONTACT)))
              }, null, 8, ["isActive", "canEdit"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFieldItems, (item) => {
                return (_openBlock(), _createBlock(_component_item_info_box, {
                  isActive: _ctx.activeBox == _ctx.BoxType.ITEMINFO,
                  canEdit: _ctx.validItemInfo,
                  onOnNext: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleNext())),
                  onOnEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleEdit(_ctx.BoxType.ITEMINFO))),
                  key: item.OrderEntityKey ?? item.OrderPackageKey,
                  item: item,
                  ref_for: true,
                  ref: "customFields"
                }, null, 8, ["isActive", "canEdit", "item"]))
              }), 128)),
              _createVNode(_component_additional_info_box, {
                isActive: _ctx.activeBox == _ctx.BoxType.ADDINFO,
                canEdit: _ctx.validAdditional,
                onOnNext: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleNext())),
                onOnEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleEdit(_ctx.BoxType.ADDINFO)))
              }, null, 8, ["isActive", "canEdit"]),
              _createVNode(_component_pre_payment_info_box, {
                appMode: "true",
                isActive: _ctx.activeBox == _ctx.BoxType.PAYMENTS,
                onOnPayment: _ctx.handlePayment,
                retry: _ctx.paymentJSON != null
              }, null, 8, ["isActive", "onOnPayment", "retry"]),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.activeBox == _ctx.BoxType.LOADING)
                  ? (_openBlock(), _createBlock(_component_LoaderDisplay, {
                      key: 0,
                      small: true
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_order_summary_info_box)
            ])
          ])
        ])),
    _createVNode(_component_alert_modal)
  ]))
}